import { CARD } from "../constants/actionTypes";
import initialState from "./initialState";

export default function cardReducer(state = initialState.card, action) {
  switch (action.type) {
    case CARD.RECEIVE_USER_CARDS_SUCCESS: {
      let card = action.cards[0];
      return Object.assign({}, state, { ...card });
    }
    case CARD.GET_USER_CARDS_STATUS: {
      let { status } = action;
      return Object.assign({}, state, { status });
    }
    case CARD.GET_CARD_TRANSACTION_HISTORY: {
      let { transactions } = action;
      return {
        ...state,
        transactions: [...state.transactions, ...transactions],
      }
    }
    case CARD.GET_AVAILABILITY: {
      let { availability } = action;
      return Object.assign({}, state, { availability });
    }
    case CARD.SHOW_ODT_MODAL: {
      let availability = { ...state.availability }
      availability.showODTModal = action.showODTModal;
      return Object.assign({}, state, { availability });
    }
    case CARD.SET_CARD_IMAGE: {
      return {
        ...state,
        cardImage: action.image
      }
    }
    case CARD.SET_MYCARD_DATA: {
      return {
        ...state,
        myCardData: action.data
      }
    }
    case CARD.SET_IS_IN_APP_CARD: {
      return {
        ...state,
        isInAppCard: action.isInAppCard
      }
    }
    default:
      return state;
  }
}
